<template>
  <BaseModal
    :model-value="settingsStore.showShare"
    @close="settingsStore.closeShare"
    :title="$t('artwork_details.share')"
  >
    <div class="sm:p-5 p-2.5 min-h-50 w-full max-w-lg">
      <div class="flex flex-wrap gap-4 justify-center">
        <SocialShare
          v-for="network in supportedNetworks"
          :key="network"
          :network="network"
          :url="url"
          :title="shareTitle"
          :description="description"
          :image="media"
          :label="false"
          :styled="true"
          class="rounded-full! p-0! size-12! flex! items-center! justify-center! hover:scale-110 transition-transform duration-200"
        />

        <button
          @click="copyToClipboard"
          class="size-12 rounded-full cursor-pointer bg-gray-100 flex items-center justify-center hover:bg-gray-200 hover:scale-110 transition-all duration-200"
        >
          <Icon name="heroicons:link" size="20" class="text-black" />
        </button>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { useMessage } from "~/stores/app-toast";
import { useSettingsStore } from "~/stores/settings";

const props = withDefaults(
  defineProps<{
    url: string;
    title?: string;
    description?: string;
    media?: string;
  }>(),
  {
    title: "MEDIUM - Armenian Art Heritage",
  },
);

const settingsStore = useSettingsStore();
const toast = useMessage();
const { t } = useI18n();

const shareTitle = computed(() => props.title || "Check out this on MEDIUM");

// The 21 supported networks by Nuxt Social Share
const supportedNetworks = [
  "facebook",
  "x",
  "linkedin",
  "pinterest",
  "reddit",
  "whatsapp",
  "telegram",
  "viber",
  "skype",
  "email",
  "threads",
  "bluesky",
  "vk",
  "mastodon",
  "tumblr",
  "line",
  "instapaper",
  "pocket",
  "hackernews",
];

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(props.url);
    toast.add(t("common.copied"), "success");
  } catch (err) {
    toast.add("Failed to copy link", "error");
  }
};
</script>
